import { Button } from "antd";
import { useState } from "react";
import { FormattedMessage } from "react-intl";
import AddAndEditStandingsModal from "~Features/Standings/AddAndEditStandingsModal";

type Props = {
  createStanding: (body: unknown) => Promise<unknown>;
  isCreatePending: boolean;
  disabled: boolean;
};
export const AddStandingModal = ({ createStanding, isCreatePending, disabled }: Props) => {
  const [isAddStandingsModalOpen, setIsAddStandingsModalOpen] = useState(false);
  return (
    <>
      <Button
        icon={<i className="fas fa-plus" style={{ marginRight: "5px" }} />}
        type="primary"
        onClick={() => setIsAddStandingsModalOpen(true)}
        disabled={disabled}
      >
        <FormattedMessage id="standings.row.add" />
      </Button>
      <AddAndEditStandingsModal
        openModal={isAddStandingsModalOpen}
        handleCloseModal={() => {
          setIsAddStandingsModalOpen(false);
        }}
        handleSendRequest={createStanding}
        okButtonLoading={isCreatePending}
      />
    </>
  );
};
